const STATE_CHIP_COLORS = {
    Created: "default",
    Processing: "warning",
    Research: "info",
    Completed: "success",
    Declined: "error",
    Negotiation: "secondary",
    ProbeSelection: "primary",
    Signing: "warning",
    Signed: "success",
};

export function getStateChipColor(stateCode) {
    if (!stateCode) return "default";
    return STATE_CHIP_COLORS[stateCode] || "default";
}

export function getStateLabel(state, t) {
    if (!state) return "—";
    if (state.name) return state.name;
    const code = state.code?.toLowerCase();
    if (code && t) {
        const translated = t(`dashboard.state.${code}`, { defaultValue: "" });
        if (translated) return translated;
    }
    return state.code || "—";
}

export function resolveStateId(row) {
    return row?.stateId ?? row?.state?.id ?? null;
}
